import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProfilePriceFilterPipe } from '@pipes/profile-price-filter/profile-price-filter';
import { AccountServiceProvider } from '@services/user/account.service';
import { User } from '@models/models';
import { Subscription } from 'rxjs';

@Component({
	selector: 'subscription-monthly',
	template: require('./subscription-monthly.html')
})
export class SubscriptionMonthlyWebComponent implements OnInit, OnDestroy {
	user: User;
	userObservable: Subscription;
	bill: string;
	coin: string;
	label: string;

	constructor(
		private accountService: AccountServiceProvider,
		private profilePricePipe: ProfilePriceFilterPipe
	) {}

	ngOnInit() {
		this.getUser();
	}

	ngOnDestroy() {
		this.userObservable.unsubscribe();
	}

	private setMonthlyPrice() {
		if (this.user && this.user.subscriptionPrice) {
			const prices = this.user.subscriptionPrice;

			const monthlyPriceType = this.user.championForever
				? 'monthlyDiscountPrice'
				: 'monthlyPrice';
			const monthlyPrice = prices[monthlyPriceType];

			this.bill = this.profilePricePipe.transform(monthlyPrice, 'bill');
			this.coin = this.profilePricePipe.transform(monthlyPrice, 'coin');
			this.label = this.profilePricePipe.transform(monthlyPrice, 'label');
		}
	}

	private getUser() {
		this.userObservable = this.accountService.userDataObservable.subscribe(
			user => {
				if (user !== null && typeof user !== 'undefined') {
					this.user = JSON.parse(JSON.stringify(user));
					this.setMonthlyPrice();
				}
			}
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/subscription/subscription-elements/subscription-monthly/subscription-monthly.ts